import React from 'react'

import PropTypes from 'prop-types'

import '../styles/feature-card4.css'

const FeatureCard4 = (props) => {
  return (
    <div className={`feature-card4-feature-card ${props.rootClassName} `}>
      <div viewBox="0 0 1024 1024" className="feature-card4-icon">
      {props.icon}
      </div>
      <h2 className="feature-card4-text">{props.title}</h2>
      <span className="feature-card4-text1">{props.description}       <a className="feature-card4-text1" href={props.url}>Click Here..</a></span>

    </div>
  )
}

FeatureCard4.defaultProps = {
  rootClassName: '',
  title: 'Lorem ipsum',
  description:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In lorem lorem, malesuada in metus vitae, scelerisque accumsan ipsum.',
  url:'',
  icon: null,
}

FeatureCard4.propTypes = {
  rootClassName: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,

  url: PropTypes.string,
  icon: PropTypes.elementType, 
}

export default FeatureCard4
